/* tslint:disable */
 
import { ActionInfo } from './action-info';
import { DashboardEntryValue } from './dashboard-entry-value';
import { DataEntryFullTextSearch } from './data-entry-full-text-search';
import { ReferenceProperty } from './reference-property';
import { StateHistory } from './state-history';

/**
 * (tsType: DashboardWithRelations, schemaOptions: { includeRelations: true })
 */
export class DashboardWithRelations {
  basedOn?: Array<ReferenceProperty>;
  creationInfo?: ActionInfo;
  dataEntity: string;
  entityVersion?: number;
  entryType?: 0 | 1;
  id?: string;

  /**
   * The reason why the entry is invalid
   */
  invalidReason?: 0 | 1;
  isImplicit?: boolean;

  /**
   * Whether the entry is invalid or not
   */
  isInvalid: boolean;
  lifeCycleStatus?: -1 | 0 | 1;
  searchIndex?: DataEntryFullTextSearch;
  specificationVersion: number;
  state: 0 | 1 | 2;
  stateHistory?: Array<StateHistory>;
  store?: ReferenceProperty;
  updateInfo?: ActionInfo;
  value: DashboardEntryValue;
  virtual?: boolean;
}
